export const customerConstants = {
  CUSTOMER_REQUEST: 'CUSTOMER_REQUEST',
  CUSTOMER_SUCCESS: 'CUSTOMER_SUCCESS',
  CUSTOMER_FAILURE: 'CUSTOMER_FAILURE',
};
